import React, { useContext, useEffect, useRef, useState } from 'react'

import clsx from 'clsx'

import { WappContext } from 'wapplr-react/dist/common/Wapp'

import Paper from 'karrierhub-ui/dist/common/src/components/Paper'
import Typography from 'karrierhub-ui/dist/common/src/components/Typography'
import ModalBase from 'karrierhub-ui/dist/common/src/components/Modal/ModalBase'

import style from './style.css'

export function SnackbarBase(props) {

    const context = useContext(WappContext)

    const { wapp } = context
    wapp.styles.use(style)

    const {
        className,
        autoHideDuration,
        color = 'paper1',
        children,
        message,
        open,
        ...rest
    } = props

    const modalRef = useRef()
    const _open = useRef(open)
    const timer = useRef(0)

    async function setOpen(open) {
        if (_open.current !== open) {
            _open.current = open
            await modalRef.actions.setOpen(open)
            await autoHide()
        }
    }

    async function autoHide() {
        if (autoHideDuration && _open.current) {
            if (timer.current) {
                clearTimeout(timer.current)
                timer.current = 0
            }
            timer.current = setTimeout(() => {
                setOpen(false)
                timer.current = 0
            }, autoHideDuration)
        }
    }

    useEffect(() => {
        if (_open.current !== open) {
            // noinspection JSIgnoredPromiseFromCall
            setOpen(open)
        }
    }, [open])

    useEffect(() => {
        // noinspection JSIgnoredPromiseFromCall
        autoHide()
    }, [])

    return (
        <ModalBase
            {...rest}
            open={_open.current}
            effect={(p) => {
                const { actions } = p
                modalRef.actions = actions
                if (rest.effect) {
                    rest.effect(p)
                }
            }}
            BackdropComponent={() => null}
            ComponentProps={{
                className: clsx(
                    style.snackbar,
                    className
                )
            }}
            disableScroll={false}
        >
            <Paper
                size={'small'}
                color={color}
                variant={'contained'}
                onClick={() => {
                    // noinspection JSIgnoredPromiseFromCall
                    setOpen(false)
                }}
                style={{
                    cursor: 'pointer'
                }}
            >
                <Typography variant={'button-default'} className={style.typography}>
                    {message || children}
                </Typography>
            </Paper>
        </ModalBase>
    )
}

export default function SnackBar(props) {

    const {
        message = '',
        autoHideDuration,
        color = 'success',
        effect,
        ...rest
    } = props

    const [{ _message, _autoHideDuration, _color }, _setMessage] = useState({
        _message: message,
        _autoHideDuration: autoHideDuration,
        _color: color
    })

    async function setMessage(_message = '', _autoHideDuration = autoHideDuration, _color = color) {
        await _setMessage({
            _message,
            _autoHideDuration,
            _color
        })
    }

    useEffect(() => {
        if (effect) {
            effect({
                actions: {
                    setMessage
                }
            })
        }
        return () => {
            if (effect) {
                effect({
                    actions: {
                        setMessage: async () => {
                        }
                    }
                })
            }
        }
    })

    return (
        <SnackbarBase
            {...rest}
            message={_message}
            autoHideDuration={_autoHideDuration}
            color={_color}
            open={!!_message}
            onClose={() => setMessage('')}
        />
    )
}
